import { DocumentDetails } from '@mercator-gcp/types/backend/Document';
import { AxiosResponse } from 'axios';
import { api } from 'hooks/useApi';
import { LandTitle } from 'types/LandTitle';
import { DocumentOverview } from 'types/TempDocument';
import type { ProjectActivitySummary } from 'types/ActivitySummary';

const getDocumentOverview = (
  documentId: DocumentDetails['id'],
): Promise<AxiosResponse<DocumentOverview>> => {
  return api.get(`/documents/${documentId}/overview`);
};

const getProjectLandTitleAssessmentValueByDocumentId = (
  documentId: DocumentDetails['id'],
): Promise<AxiosResponse<LandTitle[] | null>> => {
  return api.get(`/documents/${documentId}/transaction-property-value/`);
};

const getCompaniesInvolvedInDocument = (
  documentId: DocumentDetails['id'],
): Promise<AxiosResponse<any>> => {
  return api.get(`/v4/documents/${documentId}/companies/`);
};

const getAllDocumentEvents = (
  documentId: DocumentDetails['id'],
): Promise<AxiosResponse<any[]>> => {
  return api.get(`/documents/${documentId}/events/`);
};

const getDocumentEventsSummary = (
  documentId: DocumentDetails['id'],
): Promise<AxiosResponse<ProjectActivitySummary>> => {
  return api.get(`/documents/${documentId}/summary/`);
};

const getDocumentDetailsV3 = (uuid: string): Promise<AxiosResponse<any>> => {
  return api.get(`/v3/documents/${uuid}/`);
};

const getDocumentActivitiesV3 = (uuid: string): Promise<AxiosResponse<any>> => {
  return api.get(`/v3/documents/${uuid}/activities/`);
};

const getDocumentCompaniesV3 = (uuid: string): Promise<AxiosResponse<any>> => {
  return api.get(`/v3/documents/${uuid}/companies/`);
};

const getDocumentDetailsV4 = (documentId: string): Promise<AxiosResponse<any>> => {
  return api.get(`/v4/documents/${documentId}/`);
};

const getDocumentActivitiesV4 = (documentId: string): Promise<AxiosResponse<any>> => {
  return api.get(`/v4/documents/${documentId}/activities/`);
};

const getDocumentCompaniesV4 = (documentId: string): Promise<AxiosResponse<any>> => {
  return api.get(`/v4/documents/${documentId}/companies/`);
};

export default {
  getDocumentOverview,
  getProjectLandTitleAssessmentValueByDocumentId,
  getCompaniesInvolvedInDocument,
  getAllDocumentEvents,
  getDocumentEventsSummary,
  getDocumentDetailsV3,
  getDocumentActivitiesV3,
  getDocumentCompaniesV3,
  getDocumentDetailsV4,
  getDocumentActivitiesV4,
  getDocumentCompaniesV4,
};
